import React, { useEffect, useState } from 'react';
import { bool } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import { clickEvent, loadEvent } from '../../publisher';
import './intro-offer.style.scss';

export const IntroOffer = ({ mobile, paymentEstimatorLoaded }) => {
  const [applyNowUrl, setApplyNowUrl] = useState(null);

  useEffect(() => {
    if (paymentEstimatorLoaded) {
      loadEvent('plcc');
      const estimator = window && window.THD ? (window.THD || {}).PaymentEstimator : null;
      const { defaultApplynowLinks } = estimator || {};
      const links = defaultApplynowLinks ? defaultApplynowLinks('pip') : null;
      const url = mobile ? links?.mobileUrl : links?.desktopUrl;
      setApplyNowUrl(url);
    }
  }, [paymentEstimatorLoaded]);

  return (
    <div className="buybox-credit-promo-message">
      <Image
        src="https://assets.homedepot-static.com/p/static/images/icons/thd-consumer-creditcard.svg"
        alt="Apply Now"
        title="Apply Now"
        height={50}
        width={50}
        className="credit-card-image"
      />
      <div>
        <div><strong>Save up to $100</strong> on
          your qualifying purchase.
        </div>
        <a
          href={applyNowUrl}
          className="u__default-link"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => clickEvent('plcc')}
        >
          Apply for a Home Depot Consumer Card
        </a>
      </div>
    </div>
  );

};

IntroOffer.displayName = 'IntroOffer';

IntroOffer.propTypes = {
  mobile: bool.isRequired,
  paymentEstimatorLoaded: bool.isRequired
};
